/* Lumina product page */
(function () {
  function init(root) {
    if (!root || root.__lmp) return;
    root.__lmp = true;
    var data = {};
    try { data = JSON.parse(root.querySelector('[data-lmp-json]').textContent); } catch (e) {}
    var track = root.querySelector('[data-lmp-track]');
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    var dots = root.querySelectorAll('.lmp__dot');
    var thumbs = root.querySelectorAll('.lmp__thumb');
    var prev = root.querySelector('[data-lmp-prev]');
    var next = root.querySelector('[data-lmp-next]');
    var counter = root.querySelector('[data-lmp-current]');
    var isRTL = document.documentElement.dir === 'rtl';
    var current = 0;

    function goTo(i) {
      if (!slides[i]) return;
      track.scrollTo({ left: (isRTL ? -1 : 1) * i * track.clientWidth, behavior: 'smooth' });
    }
    function setActive(i) {
      current = i;
      dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      if (counter) counter.textContent = i + 1;
      if (prev) prev.disabled = i === 0;
      if (next) next.disabled = i === slides.length - 1;
    }
    if (track && slides.length) {
      var raf;
      track.addEventListener('scroll', function () {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(function () {
          var i = Math.round(Math.abs(track.scrollLeft) / track.clientWidth);
          if (i !== current) setActive(Math.min(i, slides.length - 1));
        });
      }, { passive: true });
      setActive(0);
    }
    root.querySelectorAll('[data-lmp-goto]').forEach(function (b) {
      b.addEventListener('click', function () { var i = +b.getAttribute('data-lmp-goto'); goTo(i); setActive(i); });
    });
    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(slides.length - 1, current + 1)); });

    var qty = root.querySelector('[data-lmp-qty-input]');
    root.querySelectorAll('[data-lmp-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.getAttribute('data-lmp-qty'), 10));
      });
    });

    function money(cents) {
      var fmt = data.moneyFormat || ('{' + '{amount}}');
      var parts = (cents / 100).toFixed(2).split('.');
      var whole = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, k) {
        if (k === 'amount_no_decimals') return whole;
        if (k === 'amount_with_comma_separator') return whole.replace(/,/g, '.') + ',' + parts[1];
        if (k === 'amount_no_decimals_with_comma_separator') return whole.replace(/,/g, '.');
        return whole + '.' + parts[1];
      });
    }
    var vSel = root.querySelector('select[data-lmp-variant]');
    var addBtn = root.querySelector('[data-lmp-add]');
    var addText = root.querySelector('[data-lmp-add-text]');
    var barAdd = root.querySelector('[data-lmp-bar-add]');
    var barPrice = root.querySelector('[data-lmp-bar-price]');
    if (vSel) {
      vSel.addEventListener('change', function () {
        var v = (data.variants || []).filter(function (x) { return String(x.id) === vSel.value; })[0];
        if (!v) return;
        var price = v.price, compare = v.compare;
        if (data.off > 0 && data.off < 100) { compare = price; price = Math.round(price * (100 - data.off) / 100); }
        root.querySelector('[data-lmp-now]').textContent = money(price);
        if (barPrice) barPrice.textContent = money(price);
        var was = root.querySelector('[data-lmp-was]'), save = root.querySelector('[data-lmp-save]');
        if (compare > price) { was.hidden = false; was.textContent = money(compare); save.hidden = false; save.textContent = '-' + Math.round((compare - price) * 100 / compare) + '%'; }
        else { was.hidden = true; save.hidden = true; }
        [addBtn, barAdd].forEach(function (b) { if (b) b.disabled = !v.available; });
        if (addText) addText.textContent = v.available ? data.addLabel : data.soldLabel;
        if (v.media > 0) { goTo(v.media - 1); setActive(v.media - 1); }
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id); history.replaceState({}, '', url.toString());
      });
    }

    var form = root.querySelector('[data-lmp-form]');
    var msg = root.querySelector('[data-lmp-msg]');
    function add() {
      if (!form || !addBtn || addBtn.disabled) return;
      addBtn.classList.add('is-loading');
      if (barAdd) barAdd.classList.add('is-loading');
      if (msg) { msg.textContent = ''; msg.classList.remove('is-error'); }
      fetch((data.cartAddUrl || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: new FormData(form) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.j && (res.j.description || res.j.message)) || 'Error');
          document.dispatchEvent(new CustomEvent('cart:item-added', { detail: { item: res.j } }));
          var api = window.essentialCartApi;
          if (api && typeof api.openCart === 'function') {
            Promise.resolve(api.refreshCart && api.refreshCart()).then(function () { api.openCart(); }, function () { api.openCart(); });
          } else {
            window.location.href = data.cartUrl || '/cart';
          }
        })
        .catch(function (err) { if (msg) { msg.textContent = err.message; msg.classList.add('is-error'); } })
        .then(function () { addBtn.classList.remove('is-loading'); if (barAdd) barAdd.classList.remove('is-loading'); });
    }
    if (form) form.addEventListener('submit', function (e) { e.preventDefault(); add(); });
    if (barAdd) barAdd.addEventListener('click', add);

    var bar = root.querySelector('[data-lmp-bar]');
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        var show = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        if (barAdd) barAdd.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
    }
  }
  function boot() { document.querySelectorAll('[data-lmp]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();